import { MAP_SEARCH_FALLBACK_TEXTS, MAP_SEARCH_TEXT_KEYS, MapSearchRenderedTexts } from './map-search-controls';

const TEXT_NAMES = ['placeholder', 'noResults', 'searchFailed'] as const;

export async function resolveSearchTexts(
  loadText: (key: string) => Promise<unknown>
): Promise<Partial<MapSearchRenderedTexts>> {
  const entries = await Promise.all(
    TEXT_NAMES.map(async (name) => {
      const key = MAP_SEARCH_TEXT_KEYS[name];
      try {
        const msg = await loadText(key);
        const usable = typeof msg === 'string' && msg.length > 0 && msg !== key;
        return [name, usable ? msg : MAP_SEARCH_FALLBACK_TEXTS[name]] as const;
      } catch {
        return [name, MAP_SEARCH_FALLBACK_TEXTS[name]] as const;
      }
    })
  );
  return Object.fromEntries(entries) as Partial<MapSearchRenderedTexts>;
}
